export const isTargetInsidePickerElements = (
  target: EventTarget | null,
  isColumnFilter: boolean | undefined,
  allowTime: boolean,
  datetimeFromMaskElement: HTMLInputElement | null,
  dateFromMaskElement: HTMLInputElement | null,
  datetimeToMaskElement: HTMLInputElement | null,
  dateToMaskElement: HTMLInputElement | null,
  datetimeRangeMaskElement: HTMLInputElement | null,
  dateRangeMaskElement: HTMLInputElement | null,
  popoverElement: HTMLDivElement | null
): boolean => {
  if (!target) return false;
  const node = target as Node;

  const resolvedInputElements: (HTMLInputElement | null)[] = isColumnFilter
    ? [
        allowTime ? datetimeFromMaskElement : dateFromMaskElement,
        allowTime ? datetimeToMaskElement : dateToMaskElement,
      ]
    : [allowTime ? datetimeRangeMaskElement : dateRangeMaskElement];

  const isDirectInputHit = resolvedInputElements.some(
    (element) => element && node.isSameNode(element)
  );

  // Initial input focus (popover closed) — let it through
  if (isDirectInputHit && popoverElement === null) {
    return false;
  }

  const isInsideAnyInput = resolvedInputElements.some(
    (element) => element?.contains(node) ?? false
  );
  const isInsidePopover = popoverElement?.contains(node) ?? false;

  return isInsideAnyInput || isInsidePopover;
};
